<div class="chat-container">
  <!-- Chat Header -->
  <dc-chat-header
    [agentCard]="agentCard"
    [isAdmin]="isAdmin"
    (showInfoEvent)="showInfo()"
    (settingsClickEvent)="changeUserChatSettings()"
    (restartConversationEvent)="restartConversation($event)"
    (completeEvent)="complete()">
  </dc-chat-header>

  <!-- Messages List -->
  <dc-chat-messages-list [chatUserSettings]="chatUserSettings" [inputMessages]="messages()"> </dc-chat-messages-list>

  <!-- Chat Footer -->
  <dc-chat-footer [micSettings]="micSettings" [flow]="conversationFlow"> </dc-chat-footer>

  <!-- Info Dialog -->
</div>

<p-dialog [style]="{ width: '100vw',}" [(visible)]="isInfoVisible" [modal]="true" [draggable]="false" [resizable]="false" header="Conversation Info">
  <div class="info-content">
    <div> points : {{ evaluationService.scoreSignal() }} </div>
    <details>
      <summary>Messages</summary>
      @for (message of messageStateService.getMessagesSignal()(); track message.messageId) {
      <h6>
        @if (message.role === 'system') {
        <b class="text-red-500" style="text-transform: capitalize">{{ message.role }}</b> - } @else {
        <b style="text-transform: capitalize">{{ message.role }}</b> - }
        <b style="color: var(--info-color); text-transform: capitalize">{{ message.messageId }}</b></h6
      >
      <p>{{ message.content }}</p>
      }
    </details>

    <details>
      <summary>Conversation Flow</summary>
      <p>Goal</p>
      <pre>{{ dynamicFlowService.conversationFlowState()?.goal.task }}</pre>
      <p>Trigger User Message</p>
      <pre>{{ dynamicFlowService.conversationFlowState()?.triggerTasks.onUserMessage.task }}</pre>
      <p>Trigger Assistant Message</p>
      <pre>{{ dynamicFlowService.conversationFlowState()?.triggerTasks.onAssistantMessage.task }}</pre>
      <p>Conditions</p>
      <pre>{{ dynamicFlowService.conversationFlowState()?.dynamicConditions | safeJson }}</pre>
      <p>Bonus</p>
      <pre>{{ dynamicFlowService.conversationFlowState()?.bonus | safeJson }}</pre>
    </details>

    <details>
      <summary>Agent Card</summary>
      <pre>{{ agentCard | safeJson }}</pre>
    </details>

    <details>
      <summary>User Settings</summary>
      <pre>{{ chatUserSettings | safeJson }}</pre>
    </details>
  </div>
</p-dialog>
